import { render, staticRenderFns } from "./delete_modal.vue?vue&type=template&id=5285ec0f&vue3"
import script from "./delete_modal.vue?vue&type=script&lang=js&vue3"
export * from "./delete_modal.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports